
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMenuBIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.09 13H6.91c-.323.009-.624-.18-.787-.493a1.11 1.11 0 0 1 0-1.014c.163-.314.464-.502.786-.493h14.182c.322-.009.623.18.786.493s.164.701 0 1.014c-.163.314-.464.502-.786.493m.028-7H2.882C2.395 6 2 5.552 2 5s.395-1 .882-1h18.236c.487 0 .882.448.882 1s-.395 1-.882 1M2.882 18h18.236c.487 0 .882.448.882 1s-.395 1-.882 1H2.882C2.395 20 2 19.552 2 19s.395-1 .882-1",
  fill: "#fff"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.09 13H6.91c-.323.009-.624-.18-.787-.493a1.11 1.11 0 0 1 0-1.014c.163-.314.464-.502.786-.493h14.182c.322-.009.623.18.786.493s.164.701 0 1.014c-.163.314-.464.502-.786.493m.028-7H2.882C2.395 6 2 5.552 2 5s.395-1 .882-1h18.236c.487 0 .882.448.882 1s-.395 1-.882 1M2.882 18h18.236c.487 0 .882.448.882 1s-.395 1-.882 1H2.882C2.395 20 2 19.552 2 19s.395-1 .882-1\" fill=\"white\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/menu-b-icon.b98c285b73041d2598a416d24f4c1393.svg"),
        {
          React: SvgMenuBIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      